<template>
  <tippy
    ref="tippyRef"
    v-bind="$attrs"
    :append-to="appendTo"
    :arrow="arrow"
    :popper-options="popperOptions"
    @hide="$emit('hide')"
    @show="$emit('show')"
  >
    <template #default="{ state: tippyState }">
      <slot name="trigger" :state="tippyState" />
    </template>

    <template #content>
      <slot />
    </template>
  </tippy>
</template>

<script lang="ts" setup>
import { ref, computed, onBeforeUnmount } from 'vue'
import { Tippy } from 'vue-tippy'
import { popperOptions } from './index'

const props = withDefaults(
  defineProps<{
    appendTo?: Element | 'parent' | ((ref: Element) => Element)
    arrow?: boolean
  }>(),
  {
    arrow: true,
  },
)

defineEmits<{
  (event: 'show'): void
  (event: 'hide'): void
}>()

const tippyRef = ref()

const tip = computed(() => tippyRef.value?.tippy)

const hide = computed(() => tippyRef.value?.hide)

const state = computed(() => tippyRef.value?.state)

const appendTo = computed(() => props.appendTo || document.body)

defineExpose({ tip, hide, state })

onBeforeUnmount(() => tip.value?.destroy())
</script>
